(() => {
  if (customElements.get('arista-cart-bogo-assist')) return;

  class AristaCartBogoAssist extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.storageKey = 'arista-cart-bogo-confirmation';
      this.state = Math.max(0, Math.min(2, Number(this.dataset.bogoCartState || 0)));
      this.saving = Math.max(0, Number(this.dataset.bogoCartSaving || 0));
      this.confirmed = this.dataset.bogoCartConfirmed === 'true';
      this.cartToken = String(this.dataset.cartToken || 'cart').slice(0, 240);
      this.celebration = this.querySelector('[data-bogo-cart-celebration]');
      this.celebrationValue = this.querySelector('[data-bogo-cart-celebration-value]');
      this.live = this.querySelector('[data-bogo-cart-live]');
      this.confetti = this.querySelector('[data-bogo-cart-confetti]');
      this.closeButton = this.querySelector('[data-bogo-cart-celebration-close]');
      this.closeButton?.addEventListener('click', () => this.hideCelebration());

      let previous = null;
      try {
        previous = JSON.parse(window.sessionStorage.getItem(this.storageKey) || 'null');
      } catch (_error) {
        // Cart guidance still works when storage is unavailable.
      }

      const confirmationKey = `${this.cartToken}:${this.saving}`;
      const transitionedToConfirmed =
        this.confirmed === true &&
        this.saving > 0 &&
        previous?.lastCelebrated !== confirmationKey;

      const nextState = {
        cartToken: this.cartToken,
        confirmed: this.confirmed,
        saving: this.saving,
        lastCelebrated: this.confirmed
          ? transitionedToConfirmed
            ? confirmationKey
            : previous?.lastCelebrated || ''
          : '',
      };
      try {
        window.sessionStorage.setItem(this.storageKey, JSON.stringify(nextState));
      } catch (_error) {
        // The confirmed cart UI still renders without storage.
      }

      if (transitionedToConfirmed) {
        this.showCelebration();
      }
    }

    disconnectedCallback() {
      if (this.timer) window.clearTimeout(this.timer);
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      this.initialized = false;
    }

    money(cents) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {
          style: 'currency',
          currency: this.dataset.currency || 'INR',
          maximumFractionDigits: 0,
        }).format(cents / 100);
      } catch (_error) {
        return `₹${Math.round(cents / 100)}`;
      }
    }

    showCelebration() {
      if (!this.celebration || !this.celebrationValue) return;
      this.celebration.hidden = false;
      if (this.live) {
        this.live.textContent = `Confirmed saving: ${this.money(this.saving)}. Your BUY1GET1 pair is ready.`;
      }

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) {
        this.celebrationValue.textContent = this.money(this.saving);
      } else {
        this.launchConfetti();
        const startedAt = performance.now();
        const duration = 850;
        const animate = (timestamp) => {
          const progress = Math.min((timestamp - startedAt) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 3);
          this.celebrationValue.textContent = this.money(Math.round(this.saving * eased));
          if (progress < 1 && !this.celebration.hidden) this.animationFrame = requestAnimationFrame(animate);
          else this.animationFrame = null;
        };
        this.animationFrame = requestAnimationFrame(animate);
      }
      this.timer = window.setTimeout(() => this.hideCelebration(), 6500);
    }

    launchConfetti() {
      if (!this.confetti) return;
      const colors = ['#9f5856', '#c68b89', '#c5a059', '#f6e2de', '#23201f'];
      const fragment = document.createDocumentFragment();
      for (let index = 0; index < 20; index += 1) {
        const piece = document.createElement('span');
        piece.style.left = `${Math.random() * 100}%`;
        piece.style.backgroundColor = colors[index % colors.length];
        piece.style.animationDelay = `${Math.random() * 0.2}s`;
        fragment.appendChild(piece);
      }
      this.confetti.replaceChildren(fragment);
    }

    hideCelebration() {
      if (this.timer) window.clearTimeout(this.timer);
      this.timer = null;
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
      this.animationFrame = null;
      if (this.celebration) this.celebration.hidden = true;
      this.confetti?.replaceChildren();
    }
  }

  customElements.define('arista-cart-bogo-assist', AristaCartBogoAssist);
})();
